import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
} from '@angular/core';

import { SkillSpecializationListItem } from '../../../models/skill-learning.model';

@Component({
  selector: 'app-skill-specialization-list',
  templateUrl: './specialization-list.component.html',
  styleUrls: ['./specialization-list.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SkillSpecializationListComponent {

  @Input() specializations: SkillSpecializationListItem[] = [];
  @Input() canManage: boolean = false;

  @Output() editRequested = new EventEmitter<string>();
  @Output() deleteRequested = new EventEmitter<string>();
  @Output() createRequested = new EventEmitter<void>();
  @Output() fillTaskRequested = new EventEmitter<string>();

  trackBySpecializationId(index: number, item: SkillSpecializationListItem): string {
    return item.id;
  }

  onEditClick(id: string): void {
    this.editRequested.emit(id);
  }

  onDeleteClick(id: string): void {
    this.deleteRequested.emit(id);
  }

  onCreateClick(): void {
    this.createRequested.emit();
  }

  onFillTaskClick(event: Event, id: string): void {
    event.stopPropagation();
    this.fillTaskRequested.emit(id);
  }

  getDisplayStatus(item: SkillSpecializationListItem): string {
    if (item && item.lastFillTask && item.lastFillTask.status === 'READY_FOR_REVIEW') {
      return 'READY_FOR_REVIEW';
    }
    if (!item || !item.status) {
      return 'DRAFT';
    }
    return item.status;
  }

  getStatusClass(item: SkillSpecializationListItem): string {
    return 'spec-list__status--' + this.getDisplayStatus(item);
  }

  getStatusLabelKey(item: SkillSpecializationListItem): string {
    return 'SKILL_LEARNING_ADMIN_STATUS_' + this.getDisplayStatus(item);
  }

  getFillTaskStatusLabelKey(item: SkillSpecializationListItem): string {
    if (!item || !item.lastFillTask || !item.lastFillTask.status) {
      return '';
    }
    return 'SKILL_LEARNING_ADMIN_FILL_TASK_STATUS_' + item.lastFillTask.status;
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/skill-learning/components/admin/specialization-list/specialization-list.component.ts